import React from 'react';

// 동시 작업 프레즌스 — 단건 편집 화면(모달/드로어/시트/패널) 상단 경고 배너.
// 목록의 점(PresenceDot.js)과 짝이 되는 나머지 한 문법이다 (docs/CAR_PRESENCE.md "웹 표시 문법").
// 화면이 배너 마크업을 직접 만들면 색·여백이 갈라지므로(리뷰 W-M3: 4벌 · 시각 3종) 여기 한 벌만 둔다.
//
// props
//   users  : [{userId,name,displayName}] — 본인 접속이 제외된 others
//            (utils/carPresence.presenceOthersLabeled). 비면 렌더하지 않는다.
//   target : '이 건'(기본) | '이 항목' | '이 차량' — 도메인이 부르는 대상 이름.
//   action : '작업 중'(기본) | '수정 중'.
//
// sticky top:0 — 폼이 길어서 그냥 두면 배너가 스크롤에 밀려 사라진다(프레즌스 3종 공통 문법).
var BANNER_STYLE = {
  position: 'sticky', top: 0, zIndex: 5,
  background: '#fef3c7', color: '#92400e', borderRadius: 8,
  padding: '10px 14px', marginBottom: 14, fontSize: 12, fontWeight: 600
};

function PresenceBanner(props) {
  var users = props.users || [];
  if (!users.length) return null;
  var names = users.map(function (u) { return u.displayName || u.name; }).join(', ');
  // role=status — 폼을 채우는 중에 배너가 나타나도 스크린리더가 알린다(포커스는 뺏지 않는다).
  return (<div role="status" style={BANNER_STYLE}>
    ⚠️ {names}님이 {props.target || '이 건'}을 {props.action || '작업 중'}입니다. 동시에 저장하면 나중 저장이 거부될 수 있습니다.
  </div>);
}

export default PresenceBanner;
